function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import ReactHintFactory from "react-hint";
import "react-hint/css/index.css";
import { SketchPicker } from "react-color";
import { COLOR_PICKER, OPTION_CLASS, LABEL, BUTTON } from "./Classes";
import { COLOR_PICKER_COLORS } from "../../Misc/Const";
var ReactHint = ReactHintFactory(React);

var ColorPicker = function (_React$Component) {
  _inherits(ColorPicker, _React$Component);

  function ColorPicker() {
    var _temp, _this, _ret;

    _classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleColorChange = function (color) {
      _this.props.onChange(color.hex);
    }, _this.renderTooltip = function () {
      var color = _this.props.color;
      return React.createElement("div", {
        style: {
          left: 55,
          bottom: 30,
          position: "relative"
        }
      }, React.createElement(SketchPicker, {
        color: color,
        colors: COLOR_PICKER_COLORS,
        width: 200,
        onChange: _this.handleColorChange
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ColorPicker.prototype.render = function render() {
    var color = this.props.color;
    return React.createElement("div", {
      className: COLOR_PICKER + " " + OPTION_CLASS
    }, React.createElement(ReactHint, {
      position: "top",
      events: {
        click: true
      },
      persist: true,
      attribute: "data-color-picker",
      onRenderContent: this.renderTooltip
    }), React.createElement("div", {
      className: LABEL
    }, "color"), React.createElement("button", {
      className: BUTTON,
      "data-color-picker": true
    }, React.createElement("div", {
      className: OPTION_CLASS + "-color",
      style: {
        backgroundColor: color
      }
    })));
  };

  return ColorPicker;
}(React.Component);

ColorPicker.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
} : {};
export default ColorPicker;